import { createContext } from 'react';

export const PageContext = createContext({
  language: 'en_US',
  setEmpty: () => {},
});
